import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import {
  BooleanField,
  ChipField,
  FunctionField,
  Labeled,
  ReferenceArrayField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  SingleFieldList,
  TextField,
} from "react-admin";
import { SectionTitle } from "features/SectionTitle";

const ShowDisciplines = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  const categoryNames = {
    1: "Основна",
    2: "Спорт",
    3: "Чужд език",
  };

  return (
    <Show
      title="Детайли за дисциплини"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Главна дисциплина">
              <ReferenceField
                source="parentId"
                reference={administrationRequests.getDisciplinesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Катедра">
              <ReferenceArrayField
                source="departmentIds"
                reference={administrationRequests.getDepartmentsSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Категория">
              <FunctionField render={record => categoryNames[record.category] || "Неизвестна категория"} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Може да се запише условно">
              <BooleanField source="isRequiredForAdvance" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Има практически изпит">
              <BooleanField source="hasPracticalExam" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowDisciplines;
